import React from "react";

import Input from "./Input";
import InputDate from "./InputDate";

import "./SettingsChat.css";

const sensorOptions = [
  { value: "Внешний датчик температуры", label: "Внешний датчик температуры" },
  {
    value: "Внутрений датчик температуры",
    label: "Внутрений датчик температуры",
  },
];

export default function SettingsChat({
  start_time,
  stop_time,
  handleChangeDate,
  settingsChat,
  handleChangeSettings,
  transportOptions,
}) {
  return (
    <div className="settings-chat">
      <div className="settings-chat-title">
        <span> График температуры </span>
      </div>

      <div className="settings-chat-row">
        <div className="settings-chat-row">
          <div className="settings-chat-col">
            <Input
              title="Транспортное средство:"
              value={settingsChat.transport}
              handleChange={(value) => handleChangeSettings("transport", value)}
              options={transportOptions}
            />

            <Input
              title="Датчик:"
              value={settingsChat.sensor}
              handleChange={(value) => handleChangeSettings("sensor", value)}
              options={sensorOptions}
            />
          </div>

          <div className="settings-chat-col">
            <InputDate
              title="Дата с:"
              value={start_time}
              handleChangeDate={(value) => handleChangeDate("start", value)}
            />

            <InputDate
              title="Дата по:"
              value={stop_time}
              handleChangeDate={(value) => handleChangeDate("stop", value)}
            />
          </div>
        </div>

        <div className="settings-chat-button">
          <button>Показать график</button>
        </div>
      </div>
    </div>
  );
}
